import React, { ChangeEvent, useContext, useEffect } from "react";
import IntercomComponent from "pages/Intercom/IntercomComponent";
import { LoadingOverlay, Page } from "components";
import { setBUToLocalStorage, setBUTypeToLocalStorage, setFeaturesListToLocalStorage } from "helpers/storage";
import { AppContext } from "config/appProvider";
import { SubscriptionContent } from "subscriptions/components/SubscriptionContent";
import { useGetBusinessUnitsQuery } from "generated/graphql";
import { useParams } from "react-router-dom";
import { SubscriptionHeader } from "subscriptions/components/SubscriptionHeader";
import { SubscribeToPro } from "subscriptions/components/SubscribeToPro";
import { ProFeatures, useSubscriptionPlanFeatures } from "feShared/subscriptions/hooks/useSubscriptionPlanFeatures";

interface Params {
  buId?: string;
}

export const Subscription: React.FC = () => {
  const { buId } = useParams<Params>();
  const { mainAppState, changeMainAppState } = useContext(AppContext);
  const { data, loading } = useGetBusinessUnitsQuery();

  const { isProFeatureEnabledForBU } = useSubscriptionPlanFeatures(mainAppState.selectedBU, true);
  const hasAnimalManagementSubscriptionFeature = isProFeatureEnabledForBU(ProFeatures.AnimalManagement);

  const handleChangeBusinessUnit = (event: ChangeEvent<HTMLSelectElement>): void => {
    setBUToLocalStorage(event.target.value);
    changeMainAppState({
      ...mainAppState,
      selectedBU: +event.target.value,
    });
  };

  useEffect(() => {
    if (buId && data?.businessUnits) {
      const bu = (data?.businessUnits || []).find((bu) => bu?.id === buId);

      if (bu) {
        changeMainAppState({
          ...mainAppState,
          selectedBU: +bu.id,
          selectedBUType: bu?.businessType?.slug || null,
          featuresList: bu.foggles,
        });
        setBUToLocalStorage(bu.id);

        if (bu?.businessType?.slug) {
          setBUTypeToLocalStorage(bu.businessType.slug);
        }
        if (bu.foggles) {
          setFeaturesListToLocalStorage(bu.foggles.toString());
        }
      }
    }
  }, [buId, data?.businessUnits]);

  return (
    <Page>
      {loading ? <LoadingOverlay /> : null}
      <SubscriptionHeader handleChangeBusinessUnit={handleChangeBusinessUnit} currentBU={mainAppState.selectedBU} />
      {hasAnimalManagementSubscriptionFeature ? (
        <SubscriptionContent currentBU={mainAppState.selectedBU} />
      ) : (
        <div className="bg-white mt-4 py-4 px-5 rounded">
          <SubscribeToPro showInvoiceHistoryButton={false} />
        </div>
      )}
      <IntercomComponent />
    </Page>
  );
};
